import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  saDetailed: any;
  url = this.api.url;
  aImage = '';
  ai = 0;
  images: any;
  constructor(private api: ApiService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.GetSRAJlGDetailed(this.route.snapshot.paramMap.get('id'));
  }
  GetSRAJlGDetailed(id: any) {
    this.api.GetSRAJlGDetailed(id).subscribe(
      data => {
        this.saDetailed = data;
        if(data.videoFiles.length === 0) {
          this.aImage = data.mediaFiles[0].path;
          this.images = data.mediaFiles
        }
      }
    )
  }
  aI(i: any, path: any) {
    this.ai = i;
    this.aImage = path;
  }
  goBack() {
    window.history.back();
  }
}
